import type {
    OrderItemBookable_V1,
    OrderItemBuyable_V1,
    OrderItemGiftCard_V1,
    OrderItemVoucher_V1,
    OrderItem_V1,
} from "./order-item-v1";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItem_V1 = (item: any): item is OrderItem_V1 => {
    return item._type === "ORDER_ITEM";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemBuyable_V1 = (item: any): item is OrderItemBuyable_V1 => {
    return isOrderItem_V1(item) && item.acquireType === "BUYABLE";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemBookable_V1 = (item: any): item is OrderItemBookable_V1 => {
    return isOrderItem_V1(item) && item.acquireType === "BOOKABLE";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemVoucher_V1 = (item: any): item is OrderItemVoucher_V1 => {
    return isOrderItem_V1(item) && item.acquireType === "VOUCHER";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemGiftCard_V1 = (item: any): item is OrderItemGiftCard_V1 => {
    return isOrderItem_V1(item) && item.acquireType === "GIFTCARD";
};

export {
    isOrderItem_V1,
    isOrderItemBookable_V1,
    isOrderItemBuyable_V1,
    isOrderItemVoucher_V1,
    isOrderItemGiftCard_V1,
};
